import { render, staticRenderFns } from "./template-list.vue?vue&type=template&id=3b8525fb"
import script from "./template-list.ts?vue&type=script&lang=ts&external"
export * from "./template-list.ts?vue&type=script&lang=ts&external"
import style0 from "./template.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports